'use strict';

(function () {
  'use strict';

  angular.module('msUtility').service('alertSvc', alertSvc);

  alertSvc.$inject = ['$log', '$timeout', '$q', 'NotifyingSvc', 'eventTrackingSvc'];

  /* @ngInject */
  function alertSvc($log, $timeout, $q, NotifyingSvc, eventTrackingSvc) {
    var alerts = [];
    ////////////////
    function getAlerts() {
      return alerts;
    }

    /**
     * Push an alert to the list, and run the callback to ensure it is displayed
     */
    function addAlert(alert) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ALERTS_UPDATED, {});
      alerts.push(alert);
      // remove the alert after 15s
      $timeout(function () {
        alerts.splice(alerts.indexOf(alert), 1);
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ALERTS_UPDATED, {});
      }, alert.timeout || 15000);
    }

    /**
     * Push a success message
     * @param  {String} message The message to display to the user
     */
    function success(message) {
      addAlert({
        type: 'success',
        message: message || 'Success'
      });
    }

    /**
     * Display an error message
     * @param  {String} message The message to display. If this is an object, it will be treated as the cause
     * @param  {Object} cause The cause of the error, which is logged
     */
    function error(message, cause) {
      $log.error(message, cause);
      // if we only got a cause, build a default message
      if (angular.isObject(message)) {
        if (message.hasOwnProperty('data') && message.data.hasOwnProperty('message')) {
          // if the response has a data object with a message property, we got a response from the API - use that as the message
          message = message.data.message;
        } else if (message.statusText && message.status) {
          // If we didn't have an API message coming back, just display the status text
          message = message.status + ': ' + message.statusText;
        } else {
          // Don't know what happened, generic message
          message = 'An unknown error occurred';
        }
      }
      addAlert({
        type: 'error',
        message: message || 'An error occurred'
      });
      eventTrackingSvc.fireEvent('error', 'general', JSON.stringify(cause), { message: message, cause: JSON.stringify(cause) });
      return $q.reject(message || 'An error occurred');
    }
    return {
      getAlerts: getAlerts,
      addAlert: addAlert,
      success: success,
      error: error
    };
  }
})();